<template>
	<div class="offline-kiosk-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.title.one')
					}}<br />
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.title.two') }}
					<strong>
						{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.title.three') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.desc.one')
					}}<br />
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.desc.two') }}
					<br />
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.desc.three') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.btn.one') }}
					</a>
					<a href="/auth/login" class="btn-type-02">
						{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-02">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_02.title.one') }}
				</h3>
				<div class="step-box">
					<ul>
						<li>
							<img :src="img.imgKioskStep01" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.one.one',
									)
								}}
								<strong>{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.one.two',
									)
								}}</strong
								><br />{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.one.three',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgKioskStep02" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.two.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.two.two',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgKioskStep03" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.three.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_02.step.three.two',
									)
								}}
							</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_04.title') }}
				</h3>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk02" alt="" />
					</div>
					<div class="card-content card-content-03">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk03" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section class="sec-05">
			<div class="container-box">
				<h3>{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_05.title') }}</h3>
				<img :src="img.imgKioskSec05" alt="" />
				<p>
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_05.desc.one')
					}}<br />
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_05.desc.two') }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import imgKioskStep01 from '@/assets/images/v2/img-kiosk-step-01.png';
import imgKioskStep02 from '@/assets/images/v2/img-kiosk-step-02.png';
import imgKioskStep03 from '@/assets/images/v2/img-kiosk-step-03.png';
import imgKioskSec05 from '@/assets/images/v2/img-kiosk-sec-05.png';
import iconKiosk01 from '@/assets/images/v2/icon/icon-kiosk-01.svg';
import iconKiosk02 from '@/assets/images/v2/icon/icon-kiosk-02.svg';
import iconKiosk03 from '@/assets/images/v2/icon/icon-kiosk-03.svg';
import imgDot from '@/assets/images/v2/img-dot.png';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgKioskStep01,
				imgKioskStep02,
				imgKioskStep03,
				imgKioskSec05,
				iconKiosk01,
				iconKiosk02,
				iconKiosk03,
				imgDot,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
	},
};
</script>
